import { getMeOptions } from '@labflow/api-client';
import type { MeResponseDto } from '@labflow/api-client';
import type { QueryClient } from '@tanstack/react-query';
import { redirect } from '@tanstack/react-router';

import { problemStatus } from '../../lib/problem-details';

export function internalReturnPath(href: string): string | undefined {
  return href.startsWith('/') && !href.startsWith('//') && !href.startsWith('/\\')
    ? href
    : undefined;
}

/**
 * 로그인만 요구하는 가드 — 온보딩·동의 게이트 밖 경로가 쓴다 (`AC-PF-01-09`·`18`).
 *
 * 로그인하지 않았으면 돌아올 경로를 들고 로그인으로 보낸다.
 */
export async function requireSession({
  queryClient,
  location,
}: {
  queryClient: QueryClient;
  location: { href: string };
}): Promise<MeResponseDto> {
  try {
    return await queryClient.ensureQueryData({ ...getMeOptions(), retry: false });
  } catch (error) {
    if (problemStatus(error) !== 401) throw error;
    throw redirect({ to: '/login', search: { return_path: internalReturnPath(location.href) } });
  }
}
